import { useState, useEffect } from 'react';
import { headerNav } from '@/mocks/home';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (anchor: string) => {
    setMobileOpen(false);
    const el = document.querySelector(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-[72px] px-4 md:px-6 max-w-[1440px] mx-auto">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="font-heading text-2xl md:text-3xl text-primary-500 tracking-wide">
            女神漫画
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer rounded-md hover:bg-primary-50"
          >
            首页
          </a>
          {headerNav.map((item) => (
            <a
              key={item.anchor}
              href={item.anchor}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.anchor);
              }}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer rounded-md hover:bg-primary-50"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                setMobileOpen(false);
              }}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer rounded-md hover:bg-primary-50"
            >
              首页
            </a>
            {headerNav.map((item) => (
              <a
                key={item.anchor}
                href={item.anchor}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.anchor);
                }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer rounded-md hover:bg-primary-50"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}